import Article1 from "../assets/article1.png";
import Article2 from "../assets/article2.png";
import Article3 from "../assets/article3.png";

const ArticlesCardData = [
    {
        imgsrc: Article1,
        title: "Crea tu página web con Notion y Super (+ Plantilla)",
        view: "https://arturocodeblog.super.site/entradas/te-ayudo-a-crear-tu-pgina-web-con-notion-y-super",
    },
    {
        imgsrc: Article2,
        title: "Organízate con esta página | Plantilla de Notion",
        view: "https://arturocodeblog.super.site/entradas/tu-pgina-principal-de-notion-perfecta",
    },
    {
        imgsrc: Article3,
        title: "Backups automáticos de Notion con tokens y GitLab",
        view: "https://arturocodeblog.super.site/entradas/backups-automticos-en-notion",
    }
]

export default ArticlesCardData